import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center border border-[#27272A] bg-[#121214] p-12">
        <img src="/assets/logo-dark-sm.png" alt="D2R" className="h-12 w-auto mx-auto mb-10" />
        <XCircle size={36} className="text-[#71717A] mx-auto" />
        <h1 className="font-display text-3xl uppercase font-bold mt-8" data-testid="payment-cancel-title">
          {t("pay.cancel.t1")} <span className="text-[#C5A059]">{t("pay.cancel.t2")}</span>
        </h1>
        <p className="text-[#A1A1AA] text-sm mt-4 leading-relaxed">
          {t("pay.cancel.text")}
        </p>
        <Link
          to="/detection"
          data-testid="payment-cancel-retry"
          className="inline-block mt-10 bg-[#C5A059] text-black px-8 py-3.5 text-xs uppercase tracking-[0.25em] font-semibold hover:bg-[#E5C07B] transition-colors duration-300"
        >
          {t("pay.cancel.cta")}
        </Link>
      </div>
    </div>
  );
}
